import React from "react";
import {
    DSGVOCheckbox,
    Form,
    InputField,
    SecondaryButton,
    SubmitButton,
    TextAreaField
} from "../Form/Form";
import {__} from "@wordpress/i18n";
import {submitForm} from "../api/requests";

const hasMinLength = (value: string, minLength: number): boolean =>
    value.trim().length >= minLength;

const isEmail = (value: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export function SingleStepContactForm(): React.ReactElement {
    const onSubmit = async (event: SubmitEvent): Promise<void> => {
        event.preventDefault();

        const form = event.target as HTMLFormElement | null;

        if (!form) {
            return;
        }

        const formData = new FormData(form);

        await submitForm('short-contact-form', {
            company: (formData.get('company') ?? '').toString(),
            function: (formData.get('function') ?? '').toString(),
            name: (formData.get('name') ?? '').toString(),
            email: (formData.get('email') ?? '').toString(),
            message: (formData.get('message') ?? '').toString(),
            dsgvo: formData.has('dsgvo'),
        });
    };

    return (
        <>
            <div className="wvcb-card">
                <div className="wvcb-contact-form wvcb-contact-form--short">
                    <p>{__('Vielen Dank für die Auswahl. Du hast dich für die schnelle Anfrage entschieden.', 'wv-chat-bot')}</p>
                    <Form onSubmit={onSubmit}>
                        <div className="container grid wrap">
                            <div className="column column--md-6">
                                <InputField
                                    label={__('Unternehmen', 'wv-chat-bot')}
                                    name="company"
                                    required
                                    validate={(value) => hasMinLength(value, 2)}
                                    validationMessage={__('Bitte einen gueltigen Unternehmensnamen eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column column--md-6">
                                <InputField
                                    label={__('Funktion', 'wv-chat-bot')}
                                    name="function"
                                    required
                                    validate={(value) => hasMinLength(value, 2)}
                                    validationMessage={__('Bitte eine Funktion angeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column column--md-6">
                                <InputField
                                    label={__('Vor- und Nachname', 'wv-chat-bot')}
                                    name="name"
                                    required
                                    validate={(value) => value.trim().split(/\s+/).length >= 2}
                                    validationMessage={__('Bitte Vor- und Nachname eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column column--md-6">
                                <InputField
                                    label={__('E-Mail', 'wv-chat-bot')}
                                    name="email"
                                    type="email"
                                    required
                                    validate={isEmail}
                                    validationMessage={__('Bitte eine gueltige E-Mail-Adresse eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column">
                                <TextAreaField
                                    label={__('Freitext', 'wv-chat-bot')}
                                    name="message"
                                    required
                                    validate={(value) => hasMinLength(value, 10)}
                                    validationMessage={__('Bitte mindestens 10 Zeichen im Freitext eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column">
                                <DSGVOCheckbox/>
                            </div>
                            <div className="column">
                                <div className="buttons">
                                    <SubmitButton label={__('Absenden', 'wv-chat-bot')}/>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    )
}
